import {
  Box,
  Divider,
  Grid,
  IconButton,
  Paper,
  Typography,
} from "@mui/material";
import React, { useEffect } from "react";
import { FaTruck } from "react-icons/fa";
import { FiCalendar, FiMap, FiUser } from "react-icons/fi";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Table from "../../components/Table";
import Layout from "../../pages/layout/Layout";
import { singleUser } from "../../../states/actions/userAction";
import Loading from "../loading/Loading";
import { useTranslation } from "react-i18next";

const UserTransaction = () => {
  const dispatch = useDispatch();

  const Role = localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo"))
    : null;

  function parseJWT(token) {
    if (Role !== null) {
      const base64Url = token.split(".")[1];
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );

      return JSON.parse(jsonPayload);
    }
  }
  const userInfo = parseJWT(Role);

  const users = useSelector((state) => state.users);
  const orders = useSelector((state) => state.orders);

  useEffect(() => {
    if (userInfo !== null || userInfo !== undefined) {
      dispatch(singleUser(userInfo.id));
    }
  }, []);
  const { t: translate } = useTranslation(["loginAndregister"]);
  return (
    <Layout title={"Users"}>
      <Box sx={{ pt: "80px", pb: "20px" }}>
        <Paper
          sx={{
            boxShadow: "none !important",
            borderRadius: "12px",
            borderStyle: "solid",
            borderWidth: "1px",
            borderColor: "divider",
            p: "20px",
          }}
        >
          <Typography variant="h5">
            {translate("WellCome")} {users?.users?.firstName}
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Box sx={{ my: 1 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <FiCalendar />
                <Typography variant="h6">
                  {translate("October")} 10, 2024
                </Typography>
              </Box>
              <Typography variant="subtitle2" sx={{ opacity: 0.7, pb: 1 }}>
                {translate("Role")} #{users?.users?.role}
              </Typography>
            </Box>
          </Box>
          <Divider />
          <Grid container spacing={3} sx={{ mt: 1 }}>
            <Grid item xs={12} sm={4}>
              <Box sx={{ display: "flex", gap: 3 }}>
                <Box>
                  <IconButton
                    sx={{
                      color: "#049bf5",
                      backgroundColor: "rgba(4,155,245, 0.2) !important",
                    }}
                  >
                    <FiUser />
                  </IconButton>
                </Box>
                <Box>
                  <Typography variant="h6" sx={{ fontSize: "20px", mb: 2 }}>
                    {translate("Customer")}
                  </Typography>
                  <Typography
                    variant="subtitle2"
                    sx={{ fontSize: "15px", mb: 2 }}
                  >
                    {translate("Name")} :{" "}
                    <span style={{ opacity: 0.7 }}>
                      {users?.users?.firstName} {users?.users?.lastName}
                    </span>
                  </Typography>
                  <Typography
                    variant="subtitle2"
                    sx={{ fontSize: "15px", mb: 2 }}
                  >
                    {translate("Email")} :{" "}
                    <span style={{ opacity: 0.7 }}>{users?.users?.email}</span>
                  </Typography>
                  <Typography
                    variant="subtitle2"
                    sx={{ fontSize: "15px", mb: 2 }}
                  >
                    {translate("Phone")} :{" "}
                    <span style={{ opacity: 0.7 }}>+251 912 077412</span>
                  </Typography>
                  <Link
                    style={{
                      padding: "3px 10px",
                      color: "#049bf5",
                      backgroundColor: "rgba(4, 155, 245,0.2)",
                      borderRadius: "5px",
                      textDecoration: "none",
                    }}
                  >
                    {translate("ViewProfile")}
                  </Link>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Box sx={{ display: "flex", gap: 3 }}>
                <Box>
                  <IconButton
                    sx={{
                      color: "#049bf5",
                      backgroundColor: "rgba(4,155,245, 0.2) !important",
                    }}
                  >
                    <FaTruck />
                  </IconButton>
                </Box>
                <Box>
                  <Typography variant="h6" sx={{ fontSize: "20px", mb: 2 }}>
                    {translate("OrderInfo")}
                  </Typography>
                  <Typography
                    variant="subtitle2"
                    sx={{ fontSize: "15px", mb: 2 }}
                  >
                    {translate("Shipping")}:{" "}
                    <span style={{ opacity: 0.7 }}>
                      {translate("KUKUexpress")}
                    </span>
                  </Typography>
                  <Typography
                    variant="subtitle2"
                    sx={{ fontSize: "15px", mb: 2 }}
                  >
                    {translate("PaymentMethod")} :{" "}
                    <span style={{ opacity: 0.7 }}>
                      {translate("TeleBirr")}
                    </span>
                  </Typography>
                  <Typography
                    variant="subtitle2"
                    sx={{ fontSize: "15px", mb: 2 }}
                  >
                    {translate("Status")} :{" "}
                    <span style={{ opacity: 0.7 }}>
                      {translate("Pending")}{" "}
                    </span>
                  </Typography>
                  <Link
                    style={{
                      padding: "3px 10px",
                      color: "#049bf5",
                      backgroundColor: "rgba(4, 155, 245,0.2)",
                      borderRadius: "5px",
                      textDecoration: "none",
                    }}
                  >
                    {translate("Viewall")}
                  </Link>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Box sx={{ display: "flex", gap: 3 }}>
                <Box>
                  <IconButton
                    sx={{
                      color: "#049bf5",
                      backgroundColor: "rgba(4,155,245, 0.2) !important",
                    }}
                  >
                    <FiMap />
                  </IconButton>
                </Box>
                <Box>
                  <Typography variant="h6" sx={{ fontSize: "20px", mb: 2 }}>
                    {translate("Delivery")}
                  </Typography>
                  <Typography
                    variant="subtitle2"
                    sx={{ fontSize: "15px", mb: 2 }}
                  >
                    {translate("City")}:{" "}
                    <span style={{ opacity: 0.7 }}>
                      {translate("BahirDar")}{" "}
                    </span>
                  </Typography>
                  <Typography
                    variant="subtitle2"
                    sx={{ fontSize: "15px", mb: 2, opacity: 0.7 }}
                  >
                    {translate("Block")}
                  </Typography>
                  <Typography
                    variant="subtitle2"
                    sx={{ fontSize: "15px", mb: 2, opacity: 0.7 }}
                  >
                    {translate("Box")}
                  </Typography>

                  <Link
                    style={{
                      padding: "3px 10px",
                      color: "#049bf5",
                      backgroundColor: "rgba(4, 155, 245,0.2)",
                      borderRadius: "5px",
                      textDecoration: "none",
                    }}
                  >
                    {translate("ViewonMap")}
                  </Link>
                </Box>
              </Box>
            </Grid>
          </Grid>
          <Typography variant="h6" sx={{ mt: 2 }}>
            {translate("Orderdetails")}
          </Typography>
          <Box sx={{ mt: 2 }}>
            {orders?.orders ? (
              <Table
                data={orders?.orders}
                fields={orderDetailsColumns}
                numberOfRows={orders?.orders?.length}
                enableTopToolBar={false}
                enableBottomToolBar={false}
                enablePagination={false}
                enableRowSelection={false}
                enableColumnFilters={false}
                enableEditing={false}
                enableColumnDragging={false}
              />
            ) : (
              <Loading />
            )}
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              mt: 2,
            }}
          >
            <Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: 3,
                  width: "200px",
                }}
              >
                <Typography variant="subtitle2">
                  {translate("Subtotal")}
                </Typography>
                <Typography variant="subtitle2" sx={{ opacity: 0.8 }}>
                  ---
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: 3,
                  width: "200px",
                }}
              >
                <Typography variant="subtitle2">
                  {translate("Tax")}(20%)
                </Typography>
                <Typography variant="subtitle2" sx={{ opacity: 0.8 }}>
                  ---
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: 3,
                  width: "200px",
                }}
              >
                <Typography variant="subtitle2">
                  {translate("Discount")}(10%)
                </Typography>
                <Typography variant="subtitle2" sx={{ opacity: 0.8 }}>
                  ---
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: 3,
                  width: "200px",
                }}
              >
                <Typography variant="h6">{translate("Total")}</Typography>
                <Typography variant="h6" sx={{ opacity: 0.8 }}>
                  --- {translate("Birr")}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Paper>
      </Box>
    </Layout>
  );
};

export default UserTransaction;

export const orderDetailsColumns = [
  {
    accessorKey: "billAmount",
    header: "Bill Amount",
  },
  {
    accessorKey: "quantity",
    header: "Quantity",
  },
  {
    accessorKey: "phoneNumber",
    header: "Phone Number",
    Cell: ({ cell }) => <span>+{cell.getValue()}</span>,
  },
  {
    accessorKey: "status",
    header: "Status",
    //or in the component override callbacks like this
    Cell: ({ cell, row }) => (
      <div>
        {row.original.status === "Pending" && ( //console.log("status : ", row),
          <span className={`status ${cell.getValue()}`}>{cell.getValue()}</span>
        )}
        {row.original.status === "Success" && (
          <span className={`status ${cell.getValue()}`}>{cell.getValue()}</span>
        )}
        {row.original.status === "Cancelled" && (
          <span className={`status ${cell.getValue()}`}>{cell.getValue()}</span>
        )}
      </div>
    ),
  },
];
